<template>
  <footer class="text-white bg-primary text-center py-4">
    <h2 class="h1 logo text-shadow">FRESH BRUNCH</h2>
    <p class="mb-0 mt-2">© 2021  All Rights Reserved.</p>
  </footer>
</template>
